import * as i0 from "@angular/core";
export class PopoverModule {
}
PopoverModule.ɵfac = function PopoverModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PopoverModule)(); };
PopoverModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PopoverModule });
PopoverModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
